import React from 'react'

const Preloader = () => {
    return (
        <div className='text-center flex justify-center align-middle h-64 animate-pulse'>
            <h1 className='text-4xl text-white'>Loading...</h1>
        </div>
    )
}

export default Preloader
